import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconChecked48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="checkmark">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M44 2H4C2.89543 2 2 2.89543 2 4V44C2 45.1046 2.89543 46 4 46H44C45.1046 46 46 45.1046 46 44V4C46 2.89543 45.1046 2 44 2ZM4 0C1.79086 0 0 1.79086 0 4V44C0 46.2091 1.79086 48 4 48H44C46.2091 48 48 46.2091 48 44V4C48 1.79086 46.2091 0 44 0H4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.7071 12.7071L18 35.4142L7.29285 24.7071L8.70706 23.2929L18 32.5858L39.2928 11.2929L40.7071 12.7071Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconChecked24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="checkmark">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 2H2L2 22H22V2ZM2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.895431 23.1046 0 22 0H2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.7071 6.70712L8.99995 18.4142L3.29285 12.7071L4.70706 11.2929L8.99995 15.5858L19.2928 5.29291L20.7071 6.70712Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconChecked16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="checkmark">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 2H2V14H14V2ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.2071 5.70712L6.49995 12.4142L2.79285 8.70712L4.20706 7.29291L6.49995 9.5858L11.7928 4.29291L13.2071 5.70712Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
